import { Select } from "@silversea-ssc/ui-components-react"
import React, { ComponentPropsWithoutRef, ReactElement } from "react"
import { getFormTitleValues } from "../../app-core/_common/form-title-values"

const _TitleSelect: React.ForwardRefRenderFunction<HTMLSelectElement, ComponentPropsWithoutRef<typeof Select>> = (
    props,
    ref,
): ReactElement => {
    const formTitleValues = getFormTitleValues()
    return (
        <Select {...props} ref={ref}>
            <option value="" />
            {Object.keys(formTitleValues).map((k) => (
                <option key={k} value={k}>
                    {formTitleValues[k]}
                </option>
            ))}
        </Select>
    )
}

export default React.forwardRef(_TitleSelect)
